// Custom display templates retain the host's row/card click behavior. Only
// controls and explicitly handled interactions own their clicks.
export function ownsRecordClick(event, boundary) {
  if (event.defaultPrevented) return true;
  const control = 'button, a, input, select, textarea, label, summary, [role="button"], [role="link"], [role="checkbox"], [role="switch"], [role="menuitem"], [data-g-stop-record-click]';
  let node = event.target?.nodeType === 1 ? event.target : event.target?.parentElement;
  while (node && node !== boundary) {
    if (node.matches(control) || node.isContentEditable) return true;
    // Alpine handlers on a custom div/span also own the click. Stop at the
    // record boundary so page-level delegated handlers do not swallow rows.
    if (node.getAttributeNames().some(name =>
      name === 'onclick' || /^(@click|x-on:click)(\.|$)/.test(name))) return true;
    node = node.parentElement;
  }
  return false;
}
